<template>
  <!-- 档案 -->
  <div id="enterprise-archives" v-if="enterpriseInfo">
    <div class="enterprise-archives-type">
      <div class="enterprise-archives-item">
        <div class="enterprise-archives-item-value">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
            :header-cell-style="{
              background: '#F5F7FA',
              color: '#111A34',
              fontWeight: 700,
            }"
          >
            <el-table-column type="index" width="40"></el-table-column>
            <el-table-column
              prop="name"
              label="录入物品"
              show-overflow-tooltip
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="location"
              label="录入位置"
              min-width="180"
              show-overflow-tooltip
            />
            <el-table-column
              prop="createName"
              label="录入人"
              min-width="140"
              show-overflow-tooltip
            />
            <el-table-column label="状态" show-overflow-tooltip min-width="100">
              <template slot-scope="scope">
                <span :style="{ color: scope.row.color }">
                  {{ scope.row.status }}</span
                ></template
              ></el-table-column
            >
            <el-table-column
              prop="gmtModified"
              label="操作时间"
              min-width="160"
            >
            </el-table-column>
            <el-table-column label="操作" width="300" fixed="right">
              <template slot="header">
                操作
                <i
                  style="cursor: pointer; color: #409eff; font-size: 16px"
                  class="el-icon-circle-plus-outline"
                  v-showFunction="{
                    active: 'add',
                    array: allFunctionButtons,
                  }"
                  @click="handleClick('', 0, false)"
                ></i>
              </template>
              <template slot-scope="scope" v-if="!scope.row.archivesList">
                <el-button
                  v-if="scope.row.status == '未领用'"
                  type="primary"
                  plain
                  size="mini"
                  @click.native="handleClick(scope.row, 1, false)"
                  v-showFunction="{
                    active: 'get',
                    array: allFunctionButtons,
                  }"
                  >领用</el-button
                >
                <el-button
                  v-if="scope.row.recipient == baseInfo.userId"
                  type="warning"
                  plain
                  size="mini"
                  @click="handleClick(scope.row, 2, false)"
                  v-showFunction="{
                    active: 'save',
                    array: allFunctionButtons,
                  }"
                  >归还</el-button
                >
                <el-button
                  v-if="scope.row.status == '未领用'"
                  type="info"
                  plain
                  size="mini"
                  @click="handleClick(scope.row, 4, false)"
                  v-showFunction="{
                    active: 'move',
                    array: allFunctionButtons,
                  }"
                  >转移</el-button
                >
                <el-button
                  v-if="
                    scope.row.status == '未领用' ||
                    scope.row.recipient == baseInfo.userId
                  "
                  type="success"
                  plain
                  size="mini"
                  @click="handleClick(scope.row, 3, false)"
                  v-showFunction="{
                    active: 'return',
                    array: allFunctionButtons,
                  }"
                  >交付</el-button
                >
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="handleClick(scope.row, 5, false)"
                  v-showFunction="{
                    active: 'record',
                    array: allFunctionButtons,
                  }"
                  >操作记录</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <div id="my-dialog" v-if="dialogData.flag">
      <my_dialog7
        :width="dialogData.width"
        :title="dialogData.title"
        :buttonArray="dialogData.buttonArray"
        :data="dialogData.data"
        :allFunctionButtons="allFunctionButtons"
        @colseDialog="colseDialog"
        @dialogOper="drawerOper"
      ></my_dialog7>
    </div>
  </div>
</template>

<script>
import * as archivesData from "@/views/archives/js/archives.js";
import * as expressageData from "@/views/expressage/js/expressage.js";
import enterpriseTable from "@/components/enterprise-components/enterprise-table";
export default {
  components: {
    enterpriseTable,
  },
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      baseInfo: {},
      tableData: [],
      tempData: {},
      pageData: {
        // 分页参数
        currentPage: 1, // 当前页数
        total: 0, // 总条目数
        pageSize: 10, // 每页条数
      },
      dialogData: {
        flag: false,
        width: "30%",
        title: "新增档案",
        buttonArray: [
          {
            text: "确认",
            active: "confirm",
          },
        ],
        data: [],
      },
      categoryList: [],
      locationList: [],
      allFunctionButtons:
        this.$featureData.getAllFunctionButtons("archivesInfo"),
    };
  },
  methods: {
    getModelFeatureAuthority() {
      console.log("获取权限");
      this.$authority.getModelFeatureAuthority(
        this,
        "archivesInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
          this.getTreeListByCategory();
          this.getTreeListByLocation();
          console.log("当前显示的按钮权限", data);
        },
      );
    },
    /**
     * 获取档案物品列表
     */
    getTreeListByCategory() {
      this.$request(
        "post",
        "/archivesCategory/getTreeList",
        { flag: false },
        (data) => {
          this.categoryList = data;
        },
        (errormessage) => {
          this.$message.error(errormessage);
        },
      );
    },
    /**
     * 获取档案柜位置列表
     */
    getTreeListByLocation() {
      this.$request(
        "post",
        "/archivesLocation/getTreeList",
        { flag: false },
        (data) => {
          this.locationList = data;
          this.initTableData();
        },
        (errormessage) => {
          this.$message.error(errormessage);
        },
      );
    },
    initTableData() {
      this.loading = true;
      let requestData = {
        clientId: this.clientInfo.id,
      };
      this.$request(
        "post",
        "/archivesInfo/listByClientId",
        requestData,
        (data) => {
          this.tableData = archivesData.getArchivesInfoTableData(data);
          console.log("tableData", this.tableData);
          this.loading = false;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    handleClick(data, flag, batch) {
      this.tempData = data;
      switch (flag) {
        // 添加
        case 0:
          // 新增档案
          this.dialogData.width = "700px";
          this.dialogData.title = "新增档案";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "sure_add",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "",
              type: "add_archives",
              data: archivesData.addArchivesDialogData(
                [],
                this.categoryList,
                this.locationList,
                false,
              ),
            },
          ];
          this.dialogData.flag = true;
          break;
        // 领用
        case 1:
          this.$confirm("确认领用该档案吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.drawerOper("sure_get");
            })
            .catch(() => {});
          break;
        // 归还
        case 2:
          this.dialogData.width = "500px";
          this.dialogData.title = "归还档案";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "sure_deposit",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "归还位置",
              type: "cascader-tree",
              value: "",
              placeholder: "请选择归还位置",
              flag: false,
              options: this.locationList,
              props: {
                multiple: false,
                value: "id",
                label: "name",
                emitPath: false,
              },
              collapse_tags: false, // 多选时是否折叠面板
              required: true,
            },
          ];
          this.dialogData.flag = true;
          break;
        // 交付
        case 3:
          this.dialogData.width = "500px";
          this.dialogData.title = "交付档案";
          this.dialogData.buttonArray = [
            {
              text: "自取",
              active: "sure_ziqu",
            },
            {
              text: "快递",
              active: "sure_youji",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "",
              type: "get_archives",
              data: {
                data: [
                  {
                    clientName: this.tempData.clientName,
                    name: [this.tempData.name],
                  },
                ],
              },
            },
          ];
          this.dialogData.flag = true;
          break;
        // 转移
        case 4:
          this.dialogData.width = "500px";
          this.dialogData.title = "转移档案";
          this.dialogData.buttonArray = [
            {
              text: "确定",
              active: "sure_move",
            },
            {
              text: "取消",
              active: "cancel",
            },
          ];
          this.dialogData.data = [
            {
              title: "转移位置",
              type: "cascader-tree",
              value: "",
              placeholder: "请选择转移位置",
              flag: false,
              options: this.locationList,
              props: {
                multiple: false,
                value: "id",
                label: "name",
                emitPath: false,
              },
              collapse_tags: false, // 多选时是否折叠面板
              required: true,
            },
          ];
          console.log("转移档案dialog显示:", this.dialogData.data);
          this.dialogData.flag = true;
          break;
        // 操作记录
        case 5:
          this.$operationRecords.showOperationRecords(
            this.tempData.id,
            "archives",
            this,
          );
          break;
        default:
          break;
      }
    },
    drawerOper(active) {
      let requestData = {};
      switch (active) {
        // 确认添加
        case "sure_add":
          let categoryIdList = [];
          this.dialogData.data[0].data.categoryList.forEach((item) => {
            categoryIdList.push(...item.categoryIdList);
          });
          requestData = {
            clientId: this.clientInfo.id,
            categoryIdList: categoryIdList,
            locationId: this.dialogData.data[0].data.locationId,
            createId: this.baseInfo.userId,
          };

          if (requestData.clientId == "") {
            this.$message.error("请选择客户名称");
            return;
          }
          if (requestData.locationId == "") {
            this.$message.error("请选择录入位置");
            return;
          }
          if (requestData.categoryIdList.length == 0) {
            this.$message.error("请选择录入物品");
            return;
          }
          this.$request(
            "post",
            "/archivesInfo/add",
            requestData,
            (data) => {
              this.$message.success("操作成功!");
              this.dialogData.flag = false;
              this.initTableData();
            },
            (errormessage) => {
              this.$message.error(errormessage);
            },
          );
          break;
        // 确认领用
        case "sure_get":
          requestData = {
            ids: [this.tempData.id], // 档案ids
            status: 1, // 档案状态：0-未领用 1-已领用 2-已交付
            locationId: "", // 档案位置 id
            recipientId: this.baseInfo.userId, // 领取人 id
            operatorId: this.baseInfo.userId, // 操作人 id
          };
          this.edit(requestData);
          break;
        // 确认归还
        case "sure_deposit":
          requestData = {
            ids: [this.tempData.id], // 档案ids
            status: 0, // 档案状态：0-未领用 1-已领用 2-已交付
            locationId: this.dialogData.data[0].value, // 档案位置 id
            recipientId: "", // 领取人 id
            operatorId: this.baseInfo.userId, // 操作人 id
          };
          if (!requestData.locationId) {
            return this.$message.error("请选择归还位置!");
          }
          this.edit(requestData);
          break;
        // 确认转移
        case "sure_move":
          requestData = {
            ids: [this.tempData.id], // 档案ids
            status: 0, // 档案状态：0-未领用 1-已领用 2-已交付
            locationId: this.dialogData.data[0].value, // 档案位置 id
            operatorId: this.baseInfo.userId, // 操作人 id
          };
          if (!requestData.locationId) {
            this.$message.error("请选择转移位置!");
            return;
          }
          this.edit(requestData);
          break;
        // 自取
        case "sure_ziqu":
          requestData = {
            ids: [this.tempData.id], // 档案ids
            status: 2, // 档案状态：0-未领用 1-已领用 2-已交付
            locationId: "", // 档案位置 id
            operatorId: this.baseInfo.userId, // 操作人 id
          };
          this.edit(requestData);
          break;
        // 快递
        case "sure_youji":
          this.dialogData.flag = false;
          this.dialogData.width = "1000px";
          this.dialogData.title = "寄件";
          this.dialogData.buttonArray = [];
          this.$request(
            "get",
            `/expressAddress/getSendAddress?userId=${this.baseInfo.userId}`,
            {},
            (data) => {
              this.$request(
                "post",
                "/archivesInfo/getDeliverable",
                {
                  clientId: this.clientInfo.id,
                  userId: this.baseInfo.userId,
                },
                (archivesData) => {
                  this.dialogData.data = [
                    {
                      title: "",
                      type: "mail",
                      data: expressageData.mailDialog(
                        data,
                        archivesData,
                        this.tempData,
                      ),
                    },
                  ];
                  this.dialogData.flag = true;
                },
                (errormessage) => {
                  this.$message.error(errormessage);
                },
              );
            },
            (errormessage) => {
              this.$message.error(errormessage);
            },
          );
          break;
        case "cancel":
          this.colseDialog();
          break;
        default:
          break;
      }
    },
    edit(requestData) {
      this.$request(
        "post",
        "/archivesInfo/edit",
        requestData,
        (data) => {
          this.$message.success("操作成功!");
          this.dialogData.flag = false;
          this.initTableData();
        },
        (errormessage) => {
          this.$message.error(errormessage);
        },
      );
    },
    // 快递下单
    order() {
      let nowData = this.dialogData.data[0].data;
      if (!nowData.sender.name) {
        this.$message.error("请输入寄件人姓名!");
        return;
      }
      if (!nowData.sender.phone) {
        this.$message.error("请输入寄件人电话!");
        return;
      }
      if (nowData.sender.code.length == 0) {
        this.$message.error("请输入寄件人省市区!");
        return;
      }
      if (!nowData.sender.address) {
        this.$message.error("请输入寄件人详细地址!");
        return;
      }
      if (!nowData.receiver.name) {
        this.$message.error("请输入收件人姓名!");
        return;
      }
      if (!nowData.receiver.phone) {
        this.$message.error("请输入收件人电话!");
        return;
      }
      if (nowData.receiver.code.length == 0) {
        this.$message.error("请输入收件人省市区!");
        return;
      }
      if (!nowData.receiver.address) {
        this.$message.error("请输入收件人详细地址!");
        return;
      }
      if (!nowData.payMethod) {
        this.$message.error("请输入支付方式!");
        return;
      }
      if (!nowData.preWeight) {
        this.$message.error("请输入货物重量!");
        return;
      }
      if (!nowData.sendStartTime) {
        this.$message.error("请输入预计送达时间!");
        return;
      }

      // if (new Date(nowData.startTime).getTime() < new Date()) {
      //   this.$message.error("预计送达时间要大于当前时间!");
      //   return;
      // }
      let flag1 = true;
      if (!this.$phoneCheck.mobilePhoneNumberCheck(nowData.sender.phone)) {
        // 做手机号格式校验
        flag1 = false;
      }
      if (!flag1) {
        this.$message({
          message: "寄件人手机号格式不正确,请确认填入正确的手机号!",
          type: "error",
          duration: 1000,
        });
        return;
      }
      let flag2 = true;
      if (!this.$phoneCheck.mobilePhoneNumberCheck(nowData.receiver.phone)) {
        // 做手机号格式校验
        flag2 = false;
      }
      if (!flag2) {
        this.$message({
          message: "收件人手机号格式不正确, 请确认填入正确的手机号!",
          type: "error",
          duration: 1000,
        });
        return;
      }
      if (!nowData.serviceAgreement) {
        this.$message.error("请先勾选我已同意");
        return;
      }
      // 设置默认值
      if (nowData.goods == "") {
        nowData.goods = "文件";
      }
      // 处理地址编码
      let senderCode = expressageData.transformCode(nowData.sender.code);
      let receiverCode = expressageData.transformCode(nowData.receiver.code);
      let activeArchives = JSON.stringify(nowData.activeArchives);
      // 构建请求数据
      let requestData = {
        companyId: this.baseInfo.company.companyId, // 公司 id
        createId: this.baseInfo.userId, // 下单人 id
        supplierName: nowData.supplierName, // 快递服务商
        goods: nowData.goods, // 物品
        expressType: nowData.expressType, // 时效产品 1-顺丰特快 2-顺丰标快
        preWeight: nowData.preWeight, // 下单重量
        isOneseIfPickup: nowData.isOneseIfPickup, // 寄件方式 1-客户同意快件自取 0-客户不同意快件自取
        sendStartTime: nowData.sendStartTime, // 期望上门时间
        payMethod: nowData.payMethod, // 支付方式
        preFreight: nowData.preFreight, // 预估运费
        deliverTime: nowData.deliverTime, // 预计送达时间
        discounts: nowData.discounts, // 折扣
        remark: nowData.remark, // 留言
        memo: nowData.memo, // 备注
        sender: {
          ...nowData.sender,
          userId: this.baseInfo.userId,
          createId: this.baseInfo.userId,
          provinceCode: senderCode.provinceCode, // 寄件人省份编码
          cityCode: senderCode.cityCode, // 寄件人城市编码
          countyCode: senderCode.countyCode, // 寄件人区县编码
          area: senderCode.area, // 寄件人省市区
        }, // 寄件人信息
        receiver: {
          ...nowData.receiver,
          createId: this.baseInfo.userId,
          provinceCode: receiverCode.provinceCode, // 收件人省份编码
          cityCode: receiverCode.cityCode, // 收件人城市编码
          countyCode: receiverCode.countyCode, // 收件人区县编码
          area: receiverCode.area, // 收件人省市区
        }, // 收件人信息
        saveOrUpdateReceiver: nowData.saveOrUpdateReceiver, // 是否保存或更新收件人信息
        archivesInfoIds: activeArchives, // 跟档案模块联动的字段，记录交付的档案 ids
      };
      this.$request(
        "post",
        "/expressOrder/send",
        requestData,
        (data) => {
          this.$message.success("下单成功!");
          this.initTableData();
          this.dialogData.flag = false;
          // this.$bus.$off("order");
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
    this.$bus.$off("order").$on("order", () => {
      this.order();
    });
  },
};
</script>

<style lang="less" scoped>
#enterprise-archives {
  width: 100%;
  background-color: #fff;
  .enterprise-archives-type {
    width: 100%;
    .enterprise-archives-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }

      .enterprise-archives-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        .enterprise-archives-item-title-search {
          display: flex;
          .search-item {
            margin-left: 5px;
          }
        }
      }
      .enterprise-archives-item-value {
        width: 100%;
      }
    }
  }
}
</style>
